<template>
  <el-dialog
    :title="isUpdate ? '修改字典项' : '添加字典项'"
    :visible="visible"
    width="440px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="96px">
      <el-form-item label="字典项名称:" prop="name">
        <el-input v-model="form.name" maxlength="20" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="字典项值:" prop="code">
        <el-input v-model="form.code" maxlength="50" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="排序号:" prop="sort">
        <el-input-number
          v-model="form.sort"
          :min="0"
          :max="9999"
          controls-position="right"
          class="ele-fluid ele-text-left" />
      </el-form-item>
      <el-form-item label="样式:">
        <el-select v-model="styleClass" clearable placeholder="请选择" class="ele-fluid">
          <el-option
            v-for="item in styleOptions"
            :key="'style-' + (item.value || 'default')"
            :label="item.label"
            :value="item.value">
            <el-tag :type="item.value || 'info'" size="mini">{{ item.label }}</el-tag>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文字颜色:">
        <el-select v-model="textClass" clearable placeholder="请选择" class="ele-fluid">
          <el-option
            v-for="item in styleOptions"
            :key="'text-' + (item.value || 'default')"
            :label="item.label"
            :value="item.value">
            <span :style="textOnlyStyle(item.value)">{{ item.label }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.name" label="效果预览:">
        <el-tag :type="previewTag.type || undefined" :style="previewTag.style" size="small">{{ form.name }}</el-tag>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input v-model="form.note" type="textarea" :rows="3" maxlength="200" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { DICT_TAG_TYPES, getDictTextOnlyStyle, resolveDictTag } from '@/utils/dict';

const defaultForm = () => ({
  name: '',
  code: '',
  sort: 0,
  list_class: '',
  note: ''
});

export default {
  name: 'DictDataEdit',
  props: {
    visible: Boolean,
    data: Object,
    dictId: Number
  },
  data() {
    return {
      form: defaultForm(),
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loading: false,
      isUpdate: false,
      styleOptions: DICT_TAG_TYPES
    };
  },
  computed: {
    previewTag() {
      return resolveDictTag(this.form.list_class);
    },
    styleClass: {
      get() {
        const listClass = this.form.list_class || '';
        if (!listClass || listClass.indexOf('text:') === 0 || listClass.charAt(0) === '#') {
          return '';
        }
        return listClass;
      },
      set(value) {
        this.$set(this.form, 'list_class', value);
      }
    },
    textClass: {
      get() {
        const listClass = this.form.list_class || '';
        if (listClass.indexOf('text:') !== 0) {
          return '';
        }
        const textValue = listClass.slice(5).trim();
        return textValue.charAt(0) === '#' ? '' : textValue;
      },
      set(value) {
        if (value === null || value === undefined || value === '') {
          if ((this.form.list_class || '').indexOf('text:') === 0) {
            this.$set(this.form, 'list_class', '');
          }
          return;
        }
        this.$set(this.form, 'list_class', 'text:' + value);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
    data() {
      if (this.visible) {
        this.initForm();
      }
    }
  },
  methods: {
    initForm() {
      if (this.data && Object.keys(this.data).length) {
        this.form = Object.assign(defaultForm(), this.data);
        this.isUpdate = true;
      } else {
        this.form = defaultForm();
        this.isUpdate = false;
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    textOnlyStyle(type) {
      return getDictTextOnlyStyle(type);
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/dictdata/edit', Object.assign({}, this.form, {
          dict_id: this.dictId
        })).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
